import axios, { AxiosRequestConfig } from 'axios'

type FetchParams = {
  url?: string
  prefix?: string
  path: string
} & Omit<AxiosRequestConfig, 'baseURL'>

axios.interceptors.request.use((config) => {
  return {
    ...config,
    headers: {
      'X-CSRF-Token': document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content'),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  }
})

function parseUrl(url: string, config: any = {}): string {
  const params = config.params
  let regex: RegExp
  if (params) {
    Object.entries(params).forEach(([key, value]: [string, any]) => {
      regex = new RegExp(`:${key}`)
      if (regex.test(url)) {
        url = url.replace(`:${key}`, value)
        delete config.params[key]
      }
    })
  }

  return url
}

function getBaseUrl({ prefix, path }: { prefix?: string; path?: string }) {
  const urlObject = {
    ...(prefix && { prefix }),
    ...(path && { path }),
  }

  return Object.values(urlObject).join('')
}

export function fetchAPI<T = any>({ path, prefix, ...options }: FetchParams) {
  return axios.request<T>({
    baseURL: parseUrl(getBaseUrl({ prefix, path }), { params: options.params }),
    ...options,
  })
}
